import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { NRadio, NSpace } from 'naive-ui'
import { ICustomItem } from '../useData'


export default /*#__PURE__*/_defineComponent({
  __name: 'radioGroup',
  props: {
    customList: null,
    initKey: null
  },
  setup(__props: any) {

const props = __props as { customList: Array<ICustomItem>, initKey: string }



const checkValue = ref(props.initKey)
const handleChangeRadio = (e: Event) => {
  checkValue.value = (e.target as HTMLInputElement).value
  props.customList.forEach(item => {
    if (item.key === (e.target as HTMLInputElement).value) {
      item.onSelect && item.onSelect()
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NSpace), {
    vertical: "",
    size: 8
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.customList, (item, idx) => {
        return (_openBlock(), _createBlock(_unref(NRadio), {
          class: "head-radio",
          checked: checkValue.value === item.key,
          value: item.key,
          key: idx,
          onChange: handleChangeRadio
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.des), 1)
          ]),
          _: 2
        }, 1032, ["checked", "value"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})